import Button from '@/components/ui/button';
import Loading from '@/components/ui/loading';

const LoadMore = ({ onLoadMore, isLoading }) => {
  return (
    <div className="pt-4 pb-2 text-center flex justify-center h-16">
      {isLoading ? (
        <Loading />
      ) : (
        <Button variant="link" onClick={() => onLoadMore()}>
          Load More
        </Button>
      )}
    </div>
  );
};

export default LoadMore;
